<template>
  <div class="stickerset1" :class="edit?'edit':''">
    <div >標籤/貼紙機台{{index}}
      <EditBtn v-if="!edit" @click="editItem=item||{name:null,printer:null};edit=true" :style="{marginLeft: 'auto'}"/>
      <BtnsS :save="'確定'" v-else @cancel="edit=false" @save="$emit('update', { $set: { [`sticker_${index}`]: editItem } })"  :style="{marginLeft: 'auto'}"/>
    </div>
    <div class="editbox" v-if="edit">
      <div><span>機台名稱 :</span><input type="text" v-model="editItem.name" placeholder="請輸入名稱(辨別用)"></div>
      <div><span>網路位置 :</span>
        <Select :width="'430px'" :borderColor="'#CACACA'" :defaultValue="editItem.printer" @input="editItem.printer=$event">
          <option :value="null">請選擇出單機台</option>
          <option v-for="(printer, p) in printers" :key="`printer-${p}`" :value="printer.str">{{printer.name}}</option>
        </Select>
      </div>
      <div><span>列印數量 :</span><input type="text" v-model.number="editItem.count" placeholder="請輸入列印數量"></div>
    </div>
    <div class="editbox" v-else>
      <div><span>機台名稱 :</span><span>{{item?.name}}</span></div>
      <div><span>網路位置 :</span><div><span>{{printer.name}}</span><span>{{printer.str}}</span></div></div>
      <div><span>列印數量 :</span><span>{{item?.count}}</span></div>
    </div>
  </div>
</template>

<script>
import EditBtn from '../../../components/btn/edit.vue'
import Select from '../../../components/select.vue'
export default {
  props: ['index', 'item', 'printers'],
  components: { EditBtn, Select },
  data () {
    return {
      edit: false,
      editItem: {
        name: null,
        printer: null,
        count: 1
      }
    }
  },
  computed: {
    printer () {
      return this.printers.find(e => e.str === this.item?.printer) || ''
    }
  },
  watch: {
    item () {
      this.edit = false
    }
  }
}
</script>

<style lang="scss" scoped>
.editbox > div > div {
  text-align: start;
  display: flex;
  flex-direction: column;
  span:nth-child(2) {
    font-size: 14px;
    color: #787878;
  }
}
.stickerset1 {
  width: 491px;
  display: flex;
  flex-direction: column;
  gap: 31px;
  &.edit {
    width: 533px;
  }
  &>:nth-child(1) {
    color: var(--color-checked);
    font-family: Roboto;
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 2.5px;
    display: flex;
  }
  .editbox {
    display: flex;
    flex-direction: column;
    gap: 26px;
    &>div {
      display: flex;
      align-items: center;
      color: #6D6D6D;
      font-family: Noto Sans TC;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 30px */
      letter-spacing: 1px;
      span {
        white-space: nowrap;
        margin-right: .5em;
        color: #6D6D6D;
        font-family: Noto Sans TC;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 30px */
        letter-spacing: 1px;
      }
    }
  }
  input[type=text] {
    display: flex;
    width: 427px;
    height: 45px;
    padding: 10px;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 5px;
    border: 1px solid#C4C4C4;
  }
}
</style>
